export enum LoginHintExpirationTypeTypes {
    DURATION = "duration",
    DATE_AND_TIME = "datetime"
}